module.exports = __webpack_public_path__ + "static/scan-rejected-65224d00b20751ce9acccc294acbd155.mp3";